<mat-form-field class="width-100" appearance="outline">
  <mat-label>
    {{ passwordLabel() | translate }}
    <ng-content select="[passwordLabelExtras]"></ng-content>
  </mat-label>
  <input
    matInput
    id="password-confirmation-password"
    name="password"
    autocomplete="new-password"
    [formControl]="passwordControl()"
    [type]="hidePassword() ? 'password' : 'text'"
    [placeholder]="'userParams.passwordPlaceholder' | translate"
    required
  />
  <button
    type="button"
    mat-icon-button
    matIconSuffix
    (mousedown)="$event.preventDefault()"
    (click)="hidePassword.set(!hidePassword())"
  >
    <mat-icon color="accent">{{ hidePassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
  </button>
  @if (passwordControl().errors?.required) {
    <mat-error>{{ 'reusable.requiredField' | translate: { field: passwordLabel() | translate } }}</mat-error>
  }
  @if (passwordControl().errors?.passwordStrength) {
    <mat-error>{{ 'userParams.passwordStrength' | translate }}</mat-error>
  }
  <ng-content select="[passwordErrors]"></ng-content>
</mat-form-field>

@if (!hideConfirmUntilPasswordTyped() || passwordControl().value) {
  <mat-form-field class="width-100" appearance="outline">
    <mat-label>
      {{ confirmLabel() | translate }}
      <ng-content select="[confirmLabelExtras]"></ng-content>
    </mat-label>
    <input
      matInput
      id="password-confirmation-confirm"
      name="password-confirmation"
      autocomplete="new-password"
      [formControl]="confirmPasswordControl()"
      [type]="hideConfirmation() ? 'password' : 'text'"
      [placeholder]="confirmLabel() | translate"
      required
    />
    <button
      type="button"
      mat-icon-button
      matIconSuffix
      (mousedown)="$event.preventDefault()"
      (click)="hideConfirmation.set(!hideConfirmation())"
    >
      <mat-icon color="accent">{{ hideConfirmation() ? 'visibility_off' : 'visibility' }}</mat-icon>
    </button>
    @if (confirmPasswordControl().errors?.required) {
      <mat-error>{{ 'reusable.requiredField' | translate: { field: confirmLabel() | translate } }}</mat-error>
    }
    @if (confirmPasswordControl().errors?.passwordMismatch) {
      <mat-error>{{ 'userParams.passwordMismatch' | translate }}</mat-error>
    }
  </mat-form-field>
}
